import { render, staticRenderFns } from "./DdForm.vue?vue&type=template&id=6e09d114&scoped=true"
import script from "./DdForm.vue?vue&type=script&lang=js"
export * from "./DdForm.vue?vue&type=script&lang=js"
import style0 from "./DdForm.vue?vue&type=style&index=0&id=6e09d114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e09d114",
  null
  
)

export default component.exports